
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const StudentsPage = lazy(() => import('../pages/students/page'));
const PartnersPage = lazy(() => import('../pages/partners/page'));
const UniversitiesPage = lazy(() => import('../pages/universities/page'));
const ProgramsPage = lazy(() => import('../pages/programs/page'));
const ApplicationsPage = lazy(() => import('../pages/applications/page'));
const DocumentsPage = lazy(() => import('../pages/documents/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const BachelorPage = lazy(() => import('../pages/programs/bachelor/page'));
const MasterPage = lazy(() => import('../pages/programs/master/page'));
const LanguagePage = lazy(() => import('../pages/programs/language/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/students',
    element: <StudentsPage />,
  },
  {
    path: '/partners',
    element: <PartnersPage />,
  },
  {
    path: '/universities',
    element: <UniversitiesPage />,
  },
  {
    path: '/programs',
    element: <ProgramsPage />,
  },
  {
    path: '/programs/bachelor',
    element: <BachelorPage />,
  },
  {
    path: '/programs/master',
    element: <MasterPage />,
  },
  {
    path: '/programs/language',
    element: <LanguagePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/applications',
    element: <ApplicationsPage />,
  },
  {
    path: '/documents',
    element: <DocumentsPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
